import { render, staticRenderFns } from "./COD-Total.vue?vue&type=template&id=56482142&scoped=true"
import script from "./COD-Total.vue?vue&type=script&lang=js"
export * from "./COD-Total.vue?vue&type=script&lang=js"
import style0 from "./COD-Total.vue?vue&type=style&index=0&id=56482142&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56482142",
  null
  
)

export default component.exports